import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { observer } from 'mobx-react';
import authStore from '../store/Auth';
import dataStore from '../store';
import { Box, Tooltip, IconButton, Avatar } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const UserTopMenu = observer(() => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getUserName = () => {
    if (!dataStore?.internalUserInfo?.userName) return '-';
    return dataStore?.internalUserInfo?.userName;
  };

  const getUserInitial = () => {
    const name = dataStore?.internalUserInfo?.userName?.trim();
    if (!name) return '-';
    return name[0].toUpperCase();
  };

  const handleGoProfile = () => {
    handleClose();
    navigate('/profile');
  };

  const handleLogout = async () => {
    await authStore.logout();
  };

  return (
    <div>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title='Account settings'>
          <IconButton
            onClick={handleClick}
            size='small'
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar
              sx={{ bgcolor: '#ff5f1f', color: '#fff', width: 32, height: 32 }}
            >
              {getUserInitial()}
            </Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        id='account-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        <MenuItem
          disabled
          disableRipple
          sx={{
            '&.Mui-disabled': {
              opacity: 1,
              color: 'text.secondary',
              cursor: 'default',
            },
            typography: 'body1',
            py: 1,
          }}
        >
          {getUserName()}
        </MenuItem>
        <Box
          sx={{
            borderTop: '1px solid',
            borderColor: 'divider',
            mx: 1,
            my: 0.5,
          }}
        />
        {authStore?.allGroups.length > 1 ? (
          <MenuItem
            onClick={() => {
              authStore.setSelectGroup(null);
              localStorage.removeItem('selectedGroup');
              handleClose();
              navigate('/');
            }}
          >
            Change Group
          </MenuItem>
        ) : null}
        {/* <MenuItem onClick={handleGoProfile}>Profile</MenuItem> */}
        <MenuItem onClick={handleLogout}>Log Out</MenuItem>
      </Menu>
    </div>
  );
});

export default UserTopMenu;
